<template>
   

        <div style="text-align:  -webkit-center; !important;">
          <div style="text-align: -webkit-center !important; font-size: 20px;padding-rigth:30px">

            <div style="padding-right: 20px;">
            

<tree-node :md="data.md" ></tree-node>

            </div>
      
    
      
  
  </div>
       
        
        
      
      </div>

    
  </template>
  <script>
  import { BButton,  BFormInput, BFormGroup, BRow, BCol, BFormCheckbox } from 'bootstrap-vue'
  import InputColorPicker from 'vue-native-color-picker'


  import 'vue-range-component/dist/vue-range-slider.css'
  import VueRangeSlider from 'vue-range-component'
  import store from '@/store/index'
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'

  import 'vue-loading-overlay/dist/vue-loading.css'
  import { ToggleButton } from 'vue-js-toggle-button'
  import Swal from 'sweetalert2'
  import vSelect from 'vue-select'
  import NodeType from './NodeType.vue'
  import TreeNode from "./TreeNode";
  
  const { url, port, auth } = store.state.appConfig.api
  const headers = {
    authentication: auth,
    'Content-Type': 'application/json',
  }
  
  export default {
    name: "TreeView",
 
    components: {
      TreeNode ,

      NodeType,
      BFormInput,
      vSelect,
      BFormGroup,
      BRow,
      BCol,
      InputColorPicker,
      VueRangeSlider,
      BButton,
      Loading,
      ToggleButton,
      BFormCheckbox
    },
    props: {
     
      data: {
        required: true,
        type: [Object, String],
        default: 0,
      },
   
      
     
    },
    data() {
      return {
        actionClicked:'',
        do_actions: ['Do split', 'Do noseque'],
        isLoadingInfo: true,
        isLoading: false,
        treeData: []
       
      
      }
    },
    created() {
      console.log("DATA IS ", this.data)
 
  
    },
    mounted(){
      const data = [
      { id: 1, name: "Elemento 1", parentId: null },
      { id: 2, name: "Elemento 2", parentId: null },
      { id: 3, name: "Elemento 3", parentId: null },
      { id: 4, name: "Elemento 4", parentId: 1 },
      { id: 5, name: "Elemento 5", parentId: 1 },
      { id: 6, name: "Elemento 6", parentId: 2 },
      { id: 7, name: "Elemento 7", parentId: 3 },
      { id: 8, name: "Elemento 8", parentId: 3 },
      { id: 9, name: "Elemento 9", parentId: 3 },
      { id: 10, name: "Elemento 10", parentId: 4 },
      { id: 11, name: "Elemento 11", parentId: 5 },
      { id: 12, name: "Elemento 12", parentId: 5 },
      { id: 13, name: "Elemento 13", parentId: null },
      { id: 14, name: "Elemento 14", parentId: 13 },
      { id: 15, name: "Elemento 15", parentId: 14 },
      { id: 16, name: "Elemento 16", parentId: 15 },
      { id: 17, name: "Elemento 17", parentId: 16 },
      { id: 18, name: "Elemento 15", parentId: 15 },
      { id: 19, name: "Elemento 16", parentId: 15 },
      { id: 20, name: "Elemento 17", parentId: 15 },
    ];
    this.treeData = this.generateTree(data);

    },
  
  
    
    methods: {
      generateTree(data) {
      let map = {},
        node,
        roots = [],
        i;
      for (i = 0; i < data.length; i++) {
        map[data[i].id] = i;
        data[i].children = [];
      }
      for (i = 0; i < data.length; i++) {
        node = data[i];
        if (node.parentId) {
          if (node.parentId) {
            data[map[node.parentId]].children.push(node);
          }
        } else {
          roots.push(node);
        }
      }
      return roots;
    }
  

    
      
     
      
    
    },
  }
  </script>
  <style>
  .icp__input {
      height: 20px!important;
      width: 20px!important;
      margin-right:10px;
  }
  .swal2-actions{
   margin: 0 10px;
    /* display: none !important;  */
  }
  .vue-range-slider.slider-component {
    margin-left:0px!important;
  }
  .sat_slider{
      margin-top: -30px!important;
      margin-bottom: 20px!important;
  }
  #new-paint .swal2-confirm swal2-styled{
    /* display: none; */
    
  }
  /* .vue-js-switch .v-switch-core[data-v-25adc6c0] {
      background-color: dodgerblue !important;
  } */
  
  </style>
  <style scoped>
  
  h4{
      display: flex;
      align-items: flex-start;
  }
  #content{
      display: flex;
      width: 100%;
      height: 400px;
      justify-content: space-between;
  }
  #picture{
      width: 55%;
      display: flex;
      align-items: center;
  }
  #picture img{
      max-width: 90%;
      max-height: 365px
  }
  #histograms{
      width: 40%;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  
  
  
  </style>
  